import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { IInstagramComment } from '../../Models/IInstagramComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';
import { InstagramService } from '../../Services/instagram.service';

@Component({
  selector: 'app-instagram-comments',
  templateUrl: './instagram-comments.component.html',
  styleUrl: './instagram-comments.component.scss'
})
export class InstagramCommentsComponent  implements OnInit {
  @Input() postId?: string;
  comments: Array<IInstagramComment> = [];

  isLoadingComments = false;
  commentCount: number = 0;
  errorComments: string = ''

  error: string = '';

  constructor(
    private instagramService: InstagramService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId)
      this.loadComments();
    else
      this.error = 'No post ID provided';
  }


  loadComments(): void {
    this.isLoadingComments = true;
    this.errorComments = '';
    
    this.instagramService.getPostComments(this.postId as string)
      .pipe(
        finalize(() => {
          this.isLoadingComments = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.comments = Array.isArray(response) ? response : [response];
            this.commentCount = this.comments.length;
          } else {
            this.errorComments = 'No comments found or invalid response format';
            console.warn('No comments data in response:', response);
          }
        },
        error: (error) => {
          this.errorComments = 'Failed to load comments. Please try again.';
          console.error('Error loading comments:', error);
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

 
 getInitials(fullName: string): string {
   return HelperFunctions.getInitials(fullName);
 }
}